import { IconCrown, IconPackage, IconStarFilled, IconTool } from "@tabler/icons-react";


export enum EnumTipoContrato {
    Premium = 1,
    Plus = 2,
    Estandar = 3,
    Instalacion = 4
}

export const TipoContratoColors = {
    [EnumTipoContrato.Premium]: "#ffd90071",
    [EnumTipoContrato.Plus]: "#96c4ffb0",
    [EnumTipoContrato.Estandar]: "#dfdfdfff",
    [EnumTipoContrato.Instalacion]: "#a8e6cfb0"
};


export const TipoContratoIconos = {
    [EnumTipoContrato.Premium]: IconCrown,
    [EnumTipoContrato.Plus]: IconStarFilled,
    [EnumTipoContrato.Estandar]: IconPackage,
    [EnumTipoContrato.Instalacion]: IconTool
};

export const TipoContratoColoresIconos = {
    [EnumTipoContrato.Premium]: "#7c6a05ff",
    [EnumTipoContrato.Plus]: "#0074d9",
    [EnumTipoContrato.Estandar]: "#292929ff",
    [EnumTipoContrato.Instalacion]: "#1a7c50ff"
};